// _guard/auth.guard.ts
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot  } from '@angular/router';
import { NotificationsService } from 'angular4-notifications';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
    	private router: Router,
    	private notificationService: NotificationsService) {}

    canActivate(route: ActivatedRouteSnapshot) {

        const expectedRoles = route.data.expectedRoles;
        let user = JSON.parse(localStorage.getItem('currentUser'));
        if (user) {
            if(user['roles'].some(r=> expectedRoles.indexOf(r) >= 0)){
                return true;
            }
        }

        // not logged in so redirect to home
        this.router.navigate(['']);
        this.notificationService.error('Oups', 'Tu dois être connecté pour accéder à cette page');
        return false;
    }
}


// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/_guard/auth.guard.ts